import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderTitle,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  editItem,
  fetchId,
  fetchIdNoloading,
  fetchStock,
  selectId,
  selectLoading,
} from "./adjustmentStockSlice";
import { useHistory, useParams } from "react-router";
import {
  showSuccessDialog,
  showErrorDialog,
  GOOGLE_KEY,
  allDay,
  getValueStatus,
  createChangeHandler,
  CallApi,
  paramsMasterAll,
  setOptionsMaster,
  showDialog,
  defaultDate,
  useForceUpdate,
} from "../../utility";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { Marker } from "../../utility/Marker";
import GoogleMapReact from "google-map-react";
import Select from "react-select";
import { selectUser } from "../../modules/Auth/_redux/authRedux";
import CurrencyInput from "react-currency-input-field";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { fetchCustomer, selectCustomer } from "../customer/customerSlice";
import { fetchUser, selectDataUser } from "../user/userSlice";
import { validate } from "@material-ui/pickers";
import InputNumber from "../../utility/InputNumber";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

export const AdjustmentStockCreate = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const user = useSelector(selectUser);
  const dataId = useSelector(selectId);
  const dataCustomer = useSelector(selectCustomer);
  const dataUser = useSelector(selectDataUser);
  const { id } = useParams();
  const forceUpdate = useForceUpdate();

  const { SearchBar } = Search;

  const [tableData, setTableData] = useState([]);
  const [sales, setSales] = useState("");
  const [optionsSales, setOptionSales] = useState([]);
  const [date, setDate] = useState(defaultDate);
  const [validasiEdit, setValidasiEdit] = useState(false);

  const paramsId = {
    adjustment_plan_id: id,
  };

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(
        fetchUser({ ...paramsMasterAll, roles: "SALES", sales_type: "CANVAS", is_active: true})
      );

      if (id !== undefined) {
        await CallApi(paramsId, fetchId, dispatch);
      }
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId) {
      const validasi = dataId.adjustment_plan_date < defaultDate;
      const initData = dataId?.adjustment_plan_details.map((item, index) => {
        return {
          ...item,
          no: index + 1,
          adjustment_quantity: parseInt(item.adjustment_quantity),
          stock_awal: parseInt(item.initial_load_quantity),
        };
      });
      setDate(dataId.adjustment_plan_date);
      setSales(dataId.user_id);
      setValidasiEdit(validasi);
      setTableData(initData);
    }
  }, [dataId]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster(dataUser, setOptionSales, "user_id", "name_username");
    }
  }, [dataUser]);

  const handleSave = async () => {
    const updatedTableData = tableData.map((item) => {
      const { no, ...rest } = item;
      return rest;
    });

    const params = {
      adjustment_plan_id: id,
      adjustment_plan_date: date,
      user_id: sales,
      adjustment_plan_details: updatedTableData,
    };

    try {
      const response =
        id === undefined
          ? await dispatch(addItem(params))
          : await dispatch(editItem(params));
      if (response.payload.status === 200) {
        await showSuccessDialog(response.payload.message);
        (await id) === undefined
          ? history.goBack()
          : await CallApi(paramsId, fetchIdNoloading, dispatch);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
      console.log(error.message);
    }
  };

  const handlePriceChange = (value, name, index) => {
    let integerValue = value ? value.replace(/(?!^-)[^0-9]/g, "") : "";
    const newData = [...tableData];
    const negative = 0 - newData[index].stock_awal;

    if (negative > integerValue) {
      integerValue = negative;
    }

    newData[index].adjustment_quantity = integerValue;
    setTableData(newData);
  };

  const handleChangeSales = async (e) => {
    if (e === null) {
      e = undefined;
      setSales("");
      setTableData([]);
    } else {
      setSales(e.value);

      const params = {
        data: "STOCKS",
        user_id: e.value,
      };

      try {
        const response = await dispatch(fetchStock(params));
        if (response.payload.data.status_code === 200) {
          const initData = response.payload.data.data?.STOCKS.map(
            (item, index) => {
              return {
                ...item,
                no: index + 1,
                adjustment_quantity: 0,
              };
            }
          );

          setTableData(initData);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    }
  };

  const handleQty = (e, row, rowIndex, formatExtraData) => {
    const negative = 0 - row.stock_awal;

    if (negative > row.adjustment_quantity) {
      row.adjustment_quantity = negative;
      forceUpdate();
      return;
    }
  };

  const inputQtyFormmater = (e, row, rowIndex, formatExtraData) => {
    return (
      <input
        type="number"
        className="input-qty"
        step="any"
        value={parseInt(row.adjustment_quantity)}
        onBlur={handleQty(e, row, rowIndex, formatExtraData)}
      />
    );
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "60px" },
      editable: false,
    },

    {
      text: "product Code",
      dataField: "product_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "product name",
      dataField: "product_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "stock",
      dataField: "stock_awal",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { minWidth: "150px" },
      editable: false,
    },
    {
      text: "adjustment quantity",
      dataField: "adjustment_quantity",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { maxWidth: "100px" },
      editable: validasiEdit === true ? false : true,

      formatExtraData: tableData,
      formatter: validasiEdit === true ? "" : inputQtyFormmater,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
    },
  ];

  console.log(validasiEdit, "validasiEdit");

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader>
          <CardHeaderTitle className="card-title">
            {id === undefined
              ? "Create Adjustment Stock"
              : "Edit Adjustment Stock"}
          </CardHeaderTitle>
          <CardHeaderToolbar>
            <Button
              className="btn btn-secondary mr-3"
              onClick={() => history.goBack()}
            >
              <i className="fa fa-arrow-left"></i>Back
            </Button>
            <Button
              className="btn btn-danger"
              onClick={(e) => {
                handleSave();
              }}
              disabled={validasiEdit}
            >
              Save
            </Button>
          </CardHeaderToolbar>
        </CardHeader>

        <CardBody>
          <Form>
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales </b>
                  </Form.Label>
                  <Col sm={6}>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={optionsSales}
                      value={getValueStatus(sales, optionsSales)}
                      placeholder="Select ..."
                      onChange={handleChangeSales}
                      isClearable={true}
                      isDisabled={id === undefined ? false : true}
                    />
                  </Col>
                </Form.Group>
              </Col>
              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Plan Date</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="date"
                      value={date}
                      min={defaultDate}
                      onChange={(e) => setDate(e.target.value)}
                      disabled={validasiEdit}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          <ToolkitProvider
            keyField="no"
            data={tableData}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <Row>
                  <Col>
                    <div className="float-right">
                      <SearchBar
                        {...props.searchProps}
                        placeholder="Search .."
                      />
                    </div>
                  </Col>
                </Row>
                <div className="table-container ">
                  <BootstrapTable
                    // wrapperClasses="table-responsive"
                    classes="table table-head-custom table-vertical-center"
                    bootstrap4
                    bordered={true}
                    {...props.baseProps}
                    cellEdit={cellEditFactory({
                      mode: "click",
                      blurToSave: true,
                    })}
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </CardBody>
      </Card>
    </>
  );
};
